import React from 'react';
import { Link } from 'gatsby';
import * as styles from './page-listing.module.scss';
import { useLocalPath } from '../../hooks';
import Img from "gatsby-image"
export const PageListing = ({ data }) => {
    const { menuItems } = data;
    return (
        <div className={`container container-lg ${styles.pageListingWrapper}`}>
            <ul className={`${styles.list} ${menuItems.length > 2 && styles.articles}`}>
                {menuItems.map(({ thumbnailTitle, thumbnailDescription, thumbnailImage, slug }: any) => (
                    <li className={styles.item} key={thumbnailTitle}>
                        {/* <GatsbyImage
                            className={styles.image}
                            image={thumbnailImage.gatsbyImageData}
                            alt={thumbnailTitle}
                        /> */}
                        <Img fluid={thumbnailImage.fluid} alt={thumbnailImage.title} className={styles.image}/>
                        <Link to={`${useLocalPath(slug)}`} className={styles.link}>
                            {thumbnailTitle}
                        </Link>
                        <p className={styles.description}>{thumbnailDescription.thumbnailDescription}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
}